import React, { useState, useEffect } from 'react';
import GroupCard from './GroupCard'; // The component to render when CardView is true
import { useQuantityContext } from '../../../QuantityContext';
import useAvailableHeight from "../../../Custom/UseAvailableHeight";
import useApi from '../../../Utilities/useAPI';
import { useParams } from 'react-router-dom';
import { Box } from "@mui/material";
import { Link } from 'react-router-dom';
import CardWaveSmile from '../../../Utilities/CardWaveSmile2'
import { ReactComponent as ImQrcode } from "../../../../Assets/img/icons/QrCode_AllCards.svg";
import { ReactComponent as IoMdShare } from "../../../../Assets/img/icons/Share.svg";
import { ReactComponent as WhatsAppFilled } from "../../../../Assets/img/icons/whatsapp-filled.svg";
import DefaultProfileBg from "../../../../Assets/img/card/profilebg.png"
import { MdOutlinePhoneIphone } from "react-icons/md";
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import FamilyDashboard from './FamilyDashboard';

const ParentGroupCard = () => {
  const { GroupCardView } = useQuantityContext();
  // console.log("GROUP CARD CONTEXT", GroupCardView);
  return (
    <>
      {/* {GroupCardView ? <PersonalCardofMembers /> : <GroupCard />} */}

      {GroupCardView === "grouptree" && <GroupCard />}
      {GroupCardView === "cards" && <PersonalCardofMembers />}
      {GroupCardView === "dashboard" && <FamilyDashboard />}
    </>
  )
};

const PersonalCardofMembers = () => {
  const { callApiFunction } = useApi();
  const { id } = useParams();

  const [availableHeight1, Column1Ref] = useAvailableHeight(140);
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetching data from the API
  useEffect(() => {
    const fetchData = async () => {
      // setIsLoading(true);
      try {
        const payload = { id: id };
        const response = await callApiFunction('getGroupMembCardDetails', payload);
        // console.log("Group card Response", response);
        if (response?.statusCode === 200) {
          setMembers(response.members);
        }
        if (response?.statusCode === 400 || response?.statusCode === 403) {
          setError("You cannot see details of this GroupCard, you are not a member.");
        }
      } catch (err) {
        setError("An error occurred while fetching the data.");
        console.error('Error fetching members:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className="container-card-display">
      <div className="items-container-card" ref={Column1Ref} style={{ height: availableHeight1 }}>
        {members.map((member, index) => (
          <>
            <Link key={index} to={`/digital-identity/Personal/${member.token}`}>

              {member.card && <div id={`${member.card.card_name}-card`} key={member.user_ref_id}>
                <div
                  className={`item-card-display digi-card-new `}>
                  <Box className="preview-card">
                    <div id='Card-firstPart-createNew'>
                      <div
                        className={`preview-card-upper `}
                        style={{
                          backgroundImage: `url(${member.card.profile_pic || DefaultProfileBg})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center"
                        }}>
                        <div className={`digi-card-label-container `}>
                          <span className='digi-card-label'>{member.card.card_name}</span>
                        </div>
                        <div>
                          <div>
                            <CardWaveSmile bgColor={"#ffff"} strokeColor={"#0044c6"} />
                            <div className="icon icon-alignment-card smile-share-icons gap-2">
                              <div className='icon-border me-3 flex-center'>
                                <ImQrcode className='icon-color' />
                              </div>
                              <div className='icon-border ms-3 flex-center'>
                                <IoMdShare className='icon-color' />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={`preview-card-names text-center `}>
                        <h3 className='truncate'>{member.card.first_name} {member.card.last_name}</h3>

                        {member.title && member.title?.length !== 0 ? (
                          <h5>{member.title}</h5>
                        ) : (
                          <h5 className='v-hidden'>{member.title}</h5>
                        )}
                      </div>

                      {member.card.summary?.length > 82 ? (
                        <div className='summary-container'>
                          {member.card.summary?.slice(0, 82) + "..."}
                        </div>
                      ) : (
                        <div className='summary-container small-summary'>
                          {member.card?.summary}
                        </div>
                      )}
                    </div>

                    <>
                      <div className='personal-card-line' />
                      <div className='quick-link-containerNew'>
                        <div className='flex-center flex-column quick-link-icon'>
                          <div className='icon icon-outside contact-icon-shadow m-0 flex-center'><MdOutlinePhoneIphone className='icon-color3' /></div>
                          <div className='contact-label'>Call</div>
                        </div>
                        <div className='flex-center flex-column quick-link-icon'>
                          <div className='icon icon-outside contact-icon-shadow m-0 flex-center'><SmsIcon className='icon-color3' /></div>
                          <div className='contact-label'>SMS</div>
                        </div>
                        <div className='flex-center flex-column quick-link-icon'>
                          <div className='icon icon-outside contact-icon-shadow m-0 flex-center'><EmailIcon className='icon-color3' /></div>
                          <div className='contact-label'>E-mail</div>
                        </div>
                        <div className='flex-center flex-column quick-link-icon'>
                          <div className='icon icon-outside contact-icon-shadow m-0 flex-center'><WhatsAppFilled className='icon-color3' /></div>
                          <div className='contact-label'>WhatsApp</div>
                        </div>
                      </div>
                    </>
                  </Box>
                </div>
              </div>}
            </Link>
          </>
        ))}
      </div>
    </div>
  );
};

export default ParentGroupCard;
